import Icon from '@ant-design/icons'

const SVG = () => (
    <svg
        t='1762391399784'
        class='icon'
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        p-id='12042'
        width='200'
        height='200'
    >
        <path
            d='M262.6227916 709.38990635v252.61009365h218.02325626V711.43097451H424.60943223v71.14052461H318.65940722v-73.21870371h-56.03661561z m296.88273194 0v252.61009365h218.02325537V711.43097451h-56.03661563v71.14052461h-105.91291406v-73.21870371h-56.03661563z m-161.6155374-296.88273194v216.24195937h217.98614531V412.50717441h-56.03661475v63.19891143H453.92660175V412.50717441H397.88998613z'
            p-id='12043'
            fill='currentColor'
        ></path>
        <path
            d='M494.8593084 62.81642744L62.41249971 327.1162792V952.64819404h147.69915908v-323.89906026h135.26719453V359.14250411h323.89906025v269.60662967h135.26719366V952.64819404h147.69915908V326.22563076z'
            p-id='12044'
            fill='currentColor'
        ></path>
    </svg>
)

export const MaterialsIcon = props => <Icon component={SVG} {...props} />
